<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6"><h1>Légumes de saison</h1></div>
      <div class="col-md-3"><Search /></div>
    </div>
  </div>
</template>
<script>
import Search from './Search.vue';

export default {
  components: {
    Search
  },
};
</script>

<style scoped lang="scss">
  h1 {
    font-family: 'Dancing Script', cursive;
    color: $title-color;
    text-shadow: -1px 1px 26px rgba(0, 0, 0, 0.4);
    text-align: center;

    margin-top: 5px;
    margin-bottom: 10px;

    @include media-breakpoint-up(md) {
      & {
        font-size: 4.062rem;
        margin-top: 10px;
        margin-bottom: 20px;
      }
    }
  }
</style>
